import axios from 'axios'
import * as Config from '../config'
import { data } from 'autoprefixer'

const instance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 1000000,
})

instance.interceptors.request.use(function (config) {
  const token = localStorage.getItem('adminLaboratoryToken')
  config.headers.Authorization = `Bearer ${token}`

  return config
})

instance.interceptors.request.use(
  (request) => {
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const API = {
  commonApi: {
    //upload image
    postImage: (props) =>
      axios.post(`${Config.UPLOAD_IMAGE}?s3_path=${props.path}`, props.data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
  },

  authApi: {
    loginApiLaboratory: ({ data, headers }) =>
      instance.post(Config.LOGIN_LABORATORY, data, { headers }),
  },

  manageLab: {
    getListLaboratoryCategoryData: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []

      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }

      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.LABORATORY_CATEGORY_LISTING}${queryString}`

      return instance.get(url)
    },
    getListLaboratorySubCategoryData: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []

      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }

      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.LABORATORY_SUB_CATEGORY_LISTING}${queryString}`

      return instance.get(url)
    },
    getLabTestList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []

      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }

      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.LAB_TEST_LISTING}${queryString}`

      return instance.get(url)
    },

    updateLabTest: ({ id, ...data }) => instance.put(`${Config.LAB_TEST_LISTING}${id}/`, data),
    deleteLabTest: ({ id }) => instance.delete(`${Config.LAB_TEST_LISTING}${id}/`),

    getLaboratoryCategoryDetails: (data) =>
      instance.get(`${Config.LABORATORY_CATEGORY_LISTING}?category_id=${data.id}`),
    getLaboratorySubCategoryDetails: (data) =>
      instance.get(`${Config.LABORATORY_SUB_CATEGORY_LISTING}?sub_category_id=${data.id}`),
    addLaboratoryCategoryData: (data) => instance.post(Config.ADD_LABORATORY_CATEGORY, data),
    addLabTestData: (data) => instance.post(Config.LAB_TEST_LISTING, data),
    addSubLaboratoryCategoryData: (data) => instance.post(Config.ADD_LABORATORY_SUB_CATEGORY, data),
    updateLaboratoryCategoryData: ({ id, ...data }) =>
      instance.put(`${Config.UPDATE_LABORATORY_CATEGORY}${id}/`, data),
    updateSubLaboratoryCategoryData: ({ id, ...data }) =>
      instance.put(`${Config.UPDATE_LABORATORY_SUB_CATEGORY}${id}/`, data),
    deleteLaboratoryCategoryData: ({ id }) =>
      instance.delete(`${Config.DELETE_LABORATORY_CATEGORY}${id}/`),
    deleteLaboratorySubCategory: (props) =>
      instance.delete(`${Config.DELETE_LABORATORY_SUB_CATEGORY}${props.id}/`),
  },
}
